import CustomInputV2 from "@components/CustomInputV2/CustomInputV2";
import { Checkbox } from "@components/ui/checkbox";
import { Label } from "@components/ui/label";
import { useState } from "react";

const ManualDraftForm = () => {
  const [isHiringCompanyVisible, setIsHiringCompanyVisible] = useState(true);

  return (
    <>
      {/* Blank Draft */}
      <div className="flex items-center p-5 border rounded-md bg-slate-100 gap-8">
        <span className="uppercase text-xs text-content-muted font-bold shrink-0">
          blank draft
        </span>
        <span className="text-xss font-medium text-light-black">
          <span className="font-semibold text-black">
            You will enter every job-post field manually.
          </span>{" "}
          COMTRACKED will still require structured skills and free-text usage
          context before review.
        </span>
      </div>
      {/* Requirement Context */}
      <div className="rounded-md border">
        <div className="flex items-center justify-between border-b px-4 py-2.5 bg-slate-50">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center rounded-full h-7 w-7 bg-slate-50 border text-xss font-bold text-light-black">
              02
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-xs">Recruitment context</span>
              <span className="text-xss font-medium text-light-black">
                Confirm the hiring-company relationship attached to this draft.
              </span>
            </div>
          </div>

          <div className="rounded-full px-2 py-1 font-bold text-xsss text-gray-600 uppercase bg-gray-100">
            Agency record
          </div>
        </div>

        <div className="grid grid-cols-[0.9fr_0.9fr_1.2fr] gap-4 p-4">
          <div className="flex flex-col gap-1.5">
            <label className="text-xss font-bold text-slate-600">
              Hiring company
            </label>
            <CustomInputV2 placeholder="Company name" />
            <span className="text-xsss text-light-black font-medium">
              Required for the internal agency record; visibility is controlled
              separately.
            </span>
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xss font-bold text-slate-600">
              Hiring-company requirement
            </label>
            <CustomInputV2 placeholder="Requirement Code" />
            <span className="text-xsss text-light-black font-medium">
              The source reference remains private to the recruitment workflow.
            </span>
          </div>
          <div className="flex flex-col rounded-md bg-slate-50 p-3 border gap-2">
            <label className="text-xsss font-bold text-slate-600 uppercase tracking-wider">
              Company-name visibility
            </label>
            <div className="flex items-start gap-2.5">
              <Checkbox
                id="hiring-company-visibility"
                checked={isHiringCompanyVisible}
                onCheckedChange={(checked) =>
                  setIsHiringCompanyVisible(checked === true)
                }
                className=""
              />
              <div className="flex flex-col gap-2 mt-0.5">
                <Label
                  htmlFor="hiring-company-visibility"
                  className="text-xss font-semibold text-black"
                >
                  Show the hiring company on the candidate job post
                </Label>
                <span className="text-xsss text-light-black font-medium">
                  Turn this off for a confidential search. The requirement
                  reference is never published; review the job copy for other
                  identifying detail.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManualDraftForm;
